export const navRoute = {
  navigateToFoodBox: '/meal-planner/food-boxes',
  navigateToCalendar: '/meal-planner/calendar',
};
